import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  groupName?: string;
  groupId?: string;
  hideFooter?: boolean;
}

const Layout = ({ children, groupName, groupId, hideFooter }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header groupName={groupName} groupId={groupId} />
      <motion.main
        className="pt-14 flex-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2 }}
      >
        {children}
      </motion.main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
